var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FMask',{staticClass:"mask-loading",attrs:{"image-path":_vm.loading,"show-text":_vm.showText,"text":_vm.loadText}})
}
var staticRenderFns = []

export { render, staticRenderFns }